export enum CheckoutRecurrenceEnum {
	// eslint-disable-next-line no-useless-escape
	SERVICE_TYPE = '[\"Mensalidade\"]',
	DESCRIPTION = 'Mensalidade',
}

export enum SubChannelEnum {
	PORTAL_DO_BENEFICIARIO = 'Portal do Beneficiário',
}

export type CheckoutRecurrenceCustomer = {
	name: string;
	email: string;
	unit: string;
	documentNumber: string;
};

export type CheckoutRecurrenceItemExtraParams = {
	serviceName: string;
	serviceType: string;
	subchannel: SubChannelEnum;
};

export type CheckoutRecurrenceItem = {
	partnerAccountId: string;
	personId: string;
	name: string;
	contactNumber: string;
	email: string;
	description: string;
	extraParams: CheckoutRecurrenceItemExtraParams;
};

export type CheckoutRecurrence = {
	items: CheckoutRecurrenceItem[];
};

export type PostCheckoutRecurrenceParams = {
	customer: CheckoutRecurrenceCustomer;
	recurrence: CheckoutRecurrence;
	'x-context': string;
	signal?: AbortSignal;
};

export type PostCheckoutRecurrenceModel = {
	content: {
		token: string;
		url: string;
	};
};

export interface PostCheckoutRecurrence {
	post: (params: PostCheckoutRecurrenceParams) => Promise<PostCheckoutRecurrenceModel>;
}
